import React from "react";

const Tvshowspage = () => {
  return (
    <div>
      <h3 className="tvshows">COMING SOON</h3>
    </div>
  );
};

export default Tvshowspage;
